const APP_META_SITE_TYPE = "website";
const APP_META_SITE_NAME = "loveishard.club";
const APP_META_SITE_DESCRIPTION =
  "Stories of real people learning to navigate complicated relationships";
const APP_META_SITE_IMAGE = undefined; //"/banner.png";
const APP_META_TITLE_SEPARATOR = "|";

export interface AppMetaProps {
  siteName?: string;
  title?: string | string[];
  description?: string | null;
  imageUrl?: string | null;
  noIndex?: boolean;
}

// const transformMeta = (value: string): string => value.toLocaleLowerCase();
const transformMeta = (value: string): string => value;

const AppMeta: FC<AppMetaProps> = ({
  description = APP_META_SITE_DESCRIPTION,
  imageUrl = APP_META_SITE_IMAGE,
  noIndex,
  siteName = APP_META_SITE_NAME,
  title: titleProp,
}) => {
  const pageTitle = useMemo<string>(() => {
    const components = Array.isArray(titleProp) ? titleProp : [titleProp];
    return components
      .filter(component => !!component)
      .join(` ${APP_META_TITLE_SEPARATOR} `);
  }, [titleProp]);
  const siteTitle = useMemo<string>(
    () =>
      [pageTitle, siteName]
        .filter(component => !!component)
        .join(` ${APP_META_TITLE_SEPARATOR} `),
    [pageTitle, siteName],
  );
  const tabTitle = useMemo<string>(
    () =>
      [pageTitle, siteName]
        .filter(component => !!component)
        .join(` ${APP_META_TITLE_SEPARATOR} `),
    [pageTitle, siteName],
  );

  return (
    <Head>
      <title>{transformMeta(tabTitle)}</title>
      {!!description && (
        <meta name="description" content={transformMeta(description)} />
      )}
      <meta property="og:site_name" content={transformMeta(siteName)} />
      <meta property="og:type" content={APP_META_SITE_TYPE} />
      {!!pageTitle && <meta property="og:title" content={pageTitle} />}
      {!!description && (
        <meta property="og:description" content={transformMeta(description)} />
      )}
      {!!imageUrl && <meta property="og:image" content={imageUrl} />}
      <meta name="twitter:card" content="summary" />
      <meta name="twitter:title" content={transformMeta(siteTitle)} />
      {!!description && (
        <meta name="twitter:description" content={transformMeta(description)} />
      )}
      {!!imageUrl && <meta name="twitter:image" content={imageUrl} />}
      {noIndex && <meta name="robots" content="noindex" />}
    </Head>
  );
};

export default AppMeta;
